import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface CharityEntry {
  charity: { uuid: string; name: string };
  role: string;
  roleLabel: string;
}

export interface AddedUser {
  firstName: string;
  lastName: string;
  email: string;
  userType: 'DONOR' | 'CHARITY' | 'FOUNDATION';
  userTypeLabel: string;
  role: string;
  roleLabel: string;
  champion: boolean;
  waitingRoom?: boolean;
  languageEditor?: boolean;
  charity?: {
    uuid: string;
    name: string;
  };
  charities?: CharityEntry[];
  hasError?: boolean;
  errorMessage?: string;
  matchedExistingUser?: boolean;
  // (GIV-5852) True when matchedExistingUser came from a still-pending invite (GsToken, no
  // gs_user row yet) rather than an already-registered active user. Only meaningful alongside
  // matchedExistingUser — an eligible pending-invite row is added exactly like an eligible
  // active-user match, but the submit response's `alreadyInvited` flag needs this to tell an
  // expected "already invited" (success, silently appends the charity) apart from a real one.
  pendingInviteMatch?: boolean;
}

@Component({
  selector: 'app-added-user-card',
  standalone: false,
  templateUrl: './added-user-card.component.html',
  styleUrls: ['./added-user-card.component.scss'],
})
export class AddedUserCardComponent {
  @Input() user!: AddedUser;
  @Input() disabled = false;
  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  onEdit(): void {
    if (!this.disabled) {
      this.edit.emit();
    }
  }

  onDelete(): void {
    if (!this.disabled) {
      this.delete.emit();
    }
  }
}
